import { LoadingIcon } from '@assets/icons';
import { InfiniteScrollGridComponents } from '@components/infiniteScroll';
import { Group } from '@components/layout';
import { Typography } from '@components/typography';
import {
  GetVolumeDataQuery,
  GetVolumeDetailsVolumeDataQuery,
  VolumeData,
} from '@generated/graphql';
import { Box } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import { VirtuosoGrid } from 'react-virtuoso';
import { GridViewItem } from './GridViewItem';

type GridViewProps = {
  directory: string[];
  loading: boolean;
  volumeData: GetVolumeDataQuery['getVolumeData']['keys'];
  volumeId: string;
  volumeMetadata: GetVolumeDetailsVolumeDataQuery['getVolumes'][0];
  fetchMore: VoidFunction;
  refetchVolumes: () => Promise<unknown>;
  setDirectory: Dispatch<SetStateAction<string[]>>;
};

export const GridView = (props: GridViewProps) => {
  const { volumeData, loading, fetchMore } = props;

  const item = (index: number, volume: VolumeData) => (
    <GridViewItem volume={volume} {...props} key={`${volume?.hash} + ${index}`} />
  );

  if (loading) {
    return (
      <Group height="100%" alignItems="center" justifyContent="center">
        <LoadingIcon size={16} />
      </Group>
    );
  }

  if (volumeData.length === 0) {
    return (
      <Box height="100%" display="flex" alignItems="center" justifyContent="center">
        <Typography style={{ userSelect: 'none' }}>No data exists in this volume.</Typography>
      </Box>
    );
  }

  return (
    <VirtuosoGrid
      totalCount={volumeData.length}
      overscan={400}
      endReached={fetchMore}
      components={InfiniteScrollGridComponents}
      data={volumeData}
      itemContent={item}
    />
  );
};
